// utils/highlight.js
export const highlightText = (text, keyword) => {
	if (!keyword) return text;
	const regex = new RegExp(`(${keyword.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')})`, 'gi');
	return text.replace(regex, '<mark>$1</mark>');
};
